import React, { Component } from 'react';
import { connect } from 'react-redux';
import { withRouter, Prompt } from 'react-router-dom';
import { bindActionCreators } from 'redux';
import PropTypes from 'prop-types';
import OrderDetail from './orderDetail/OrderDetail';
import RFQDetail from './rfqDetail/RFQDetail';
import IsinEntry from '../isinDetail/IsinEntry';
import IsinDetail from '../isinDetail/IsinDetail';
import RecordFooterComponent from './RecordFooter';
import { TYPE } from '../utility/types';

import * as recordDetailActions from './reducer';
import * as isinDetailActions from '../isinDetail/reducer';
import * as staticDataActions from '../staticData/reducer';
import * as recentlyUsedValuesActions from '../recentlyUsed/reducer';
import * as stateActions from './states/states';

import './RecordDetail.css';

export class RecordDetailComponent extends Component {
  static get propTypes() {
    return {
      user: PropTypes.shape({
        CanView: PropTypes.bool
      }),
      type: PropTypes.oneOf(TYPE.values),
      id: PropTypes.number,
      onFetch: PropTypes.func.isRequired,
      onFetchProduct: PropTypes.func.isRequired,
      currentRecord: PropTypes.object,
      currentType: PropTypes.string,
      onStartEditing: PropTypes.func,
      editing: PropTypes.bool,
      unsavedChanges: PropTypes.bool,
      clipboardDate: PropTypes.any,
      showIsin: PropTypes.bool,
      recentlyUsed: PropTypes.object,
      staticData: PropTypes.object,
      onFetchStaticData: PropTypes.func.isRequired,
      onFetchClients: PropTypes.func,
      onFetchRecentlyUsed: PropTypes.func,
      onUpdateProperty: PropTypes.func.isRequired,
      onSaveRecord: PropTypes.func,
      onCancelEditing: PropTypes.func,
      onNewRecord: PropTypes.func,
      onSetCurrentTime: PropTypes.func,
      availableStates: PropTypes.arrayOf(PropTypes.shape({
        name: PropTypes.string
      })),
      onChangeState: PropTypes.func,
      onCopyDate: PropTypes.func,
      onSetAcceptedTime: PropTypes.func,
      onFetchNotional: PropTypes.func
    };
  }

  constructor(props) {
    super(props);
    const { user, onFetch, onFetchStaticData, onFetchRecentlyUsed } = this.props;

    if (user && user.CanView && props.id) {
      onFetch(this.props.type, this.props.id);
    }
    this.details = undefined;
    // Fetch the static data initially, can later be done only upon entering edit mode / creating record
    onFetchStaticData();
    // Fetch the recently used values
    onFetchRecentlyUsed();
  }

  componentWillReceiveProps(props) {
    if (props.user && props.user.CanView && props.id) {
      this.props.onFetch(props.type, props.id);
    }

    if (props.currentRecord) {
      const productId = props.currentRecord.Product ? props.currentRecord.Product.ProductId : null;
      this.props.onFetchProduct(productId);
    }
  }

  componentDidUpdate(prevProps) {
    if (prevProps.id !== this.props.id) {
      this.clearErrors();
    }
  }

  validate() {
    if (this.details && this.details.validate) {
      return this.details.validate();
    }

    return true;
  }

  clearErrors() {
    if (this.details && this.details.clearErrors) {
      this.details.clearErrors();
    }
  }

  onSubmitForm(event) {
    const { editing, onSaveRecord } = this.props;
    event.preventDefault();

    if (editing) {
      if (this.form) {
        this.form.querySelector('input[type=submit]').focus();
      }

      setTimeout(() => {
        let valid = this.validate();

        if (valid && this.doValidateProxy && this.doValidateProxy.validate) {
          valid = this.doValidateProxy.validate();
        }
        if (valid) {
          onSaveRecord();
        }
      });
    }
  }

  render() {
    const { currentRecord, type, currentType, editing, unsavedChanges } = this.props;

    if (!currentRecord || (currentType !== type)) {
      return (
        <div className="RecordDetail-empty">Nothing Selected</div>
      );
    }

    return (<form
      className="RecordDetail"
      ref={(form) => { this.form = form; }}
      onSubmit={event => this.onSubmitForm(event)}
    >
      <Prompt
        when={editing && unsavedChanges}
        message="Are you sure you want to discard the changes?"
      />
      <div className="RecordDetail-detail">
        {this.renderRecordDetail()}
        {this.renderIsinDetail()}
      </div>

      { this.renderFooter() }
    </form>);
  }

  onCopyCurrentRecord() {
    const { currentRecord, onNewRecord } = this.props;
    onNewRecord(currentRecord);
  }

  renderIsinDetail() {
    const { showIsin, recentlyUsed, clipboardDate, onCopyDate } = this.props;

    this.doValidateProxy = {};

    return (<div className="RecordDetail-column">
      <IsinDetail
        doValidateProxy={this.doValidateProxy}
        clipboardDate={clipboardDate}
        onCopyDate={onCopyDate}
      />
      {showIsin && <IsinEntry recentlyUsed={recentlyUsed} doValidateProxy={this.doValidateProxy} />}
    </div>);
  }

  renderRecordDetail() {
    const { currentRecord, currentType,
      editing, staticData, onUpdateProperty,
      onSetCurrentTime, onFetchClients,
      recentlyUsed, clipboardDate, onCopyDate, onSetAcceptedTime, onFetchNotional
    } = this.props;

    return (<div className="RecordDetail-column">
      {currentType === TYPE.ORDER
        ? <OrderDetail
          ref={(instance) => { this.details = instance; }}
          record={currentRecord}
          currentType={currentType}
          onFetchClients={onFetchClients}
          editing={editing}
          recentlyUsed={recentlyUsed}
          staticData={staticData}
          onUpdateProperty={onUpdateProperty}
          onSetCurrentTime={onSetCurrentTime}
          clipboardDate={clipboardDate}
          onCopyDate={onCopyDate}
          onFetchNotional={onFetchNotional}
        />
        : <RFQDetail
          ref={(instance) => { this.details = instance; }}
          record={currentRecord}
          currentType={currentType}
          onFetchClients={onFetchClients}
          editing={editing}
          recentlyUsed={recentlyUsed}
          staticData={staticData}
          onUpdateProperty={onUpdateProperty}
          onSetCurrentTime={onSetCurrentTime}
          clipboardDate={clipboardDate}
          onCopyDate={onCopyDate}
          onSetAcceptedTime={onSetAcceptedTime}
          onFetchNotional={onFetchNotional}
        />}
    </div>);
  }

  renderFooter() {
    const { editing, currentType, currentRecord, onStartEditing,
      onCancelEditing, availableStates, onChangeState } = this.props;

    const state = stateActions.getCurrentState(currentType, currentRecord);
    const footerProps = { editing, state, onStartEditing, onCancelEditing, availableStates, onChangeState };

    return <RecordFooterComponent {...footerProps} onCopy={() => this.onCopyCurrentRecord()} />;
  }
}

const mapStateToProps = state => ({
  ...state.recordDetail,
  recentlyUsed: state.recentlyUsed.values,
  showIsin: state.isinDetail.requiresLookup || !state.isinDetail.product || !state.isinDetail.product.InstrumentTypeId,
  staticData: state.staticData,
  availableStates: stateActions.getAvailableStates(state.recordDetail.currentType, state.recordDetail.currentRecord),
  user: state.user.current
});

const mapDispatchToProps = (dispatch) => {
  const {
    fetchRecordIfNeeded,
    startEditing,
    cancelEditing,
    setRecordProperty,
    saveRecord,
    newRecord,
    setCurrentTime,
    copyDate,
    setAcceptedTime,
    fetchNotional
  } = bindActionCreators(recordDetailActions, dispatch);

  const {
    fetchProductIfNeeded
  } = bindActionCreators(isinDetailActions, dispatch);

  const {
    fetchStaticDataIfNeeded,
    fetchClients
  } = bindActionCreators(staticDataActions, dispatch);

  const {
    getRecentlyUsedFromBrowser,
    storeToRecentlyUsed
  } = bindActionCreators(recentlyUsedValuesActions, dispatch);


  const {
    changeState
  } = bindActionCreators(stateActions, dispatch);


  return {
    onFetch: fetchRecordIfNeeded,
    onFetchProduct: fetchProductIfNeeded,
    onStartEditing: startEditing,
    onCancelEditing: cancelEditing,
    onFetchStaticData: fetchStaticDataIfNeeded,
    onFetchClients: fetchClients,
    onFetchRecentlyUsed: getRecentlyUsedFromBrowser,
    onStoreToRecentlyUsed: storeToRecentlyUsed,
    onUpdateProperty: setRecordProperty,
    onSaveRecord: saveRecord,
    onNewRecord: newRecord,
    onSetCurrentTime: setCurrentTime,
    onChangeState: changeState,
    onCopyDate: copyDate,
    onSetAcceptedTime: setAcceptedTime,
    onFetchNotional: fetchNotional
  };
};

const RecordDetail = withRouter(connect(
  mapStateToProps,
  mapDispatchToProps
)(RecordDetailComponent));
export default RecordDetail;



// WEBPACK FOOTER //
// ./src/recordDetail/RecordDetail.js